// extracted by mini-css-extract-plugin
export default {"bar":"TablePagination_bar__8hu5a","buttons":"TablePagination_buttons__khIrQ","label":"TablePagination_label__MSdz8"};